import React, { useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import Button from './Button';

import 'assets/css/Modal.min.css';

import useOutsideAlerter from 'functions/useOutsideAlerter';
import clg from 'functions/log';
import makeid from 'functions/makeid';
import useDidMountEffect from 'functions/useDidMountEffect';

const modalId = `modal-${makeid(8)}`

const Modal = (props) => {

    const modalBodyRef = useRef(null);

    

    const close = () => {
        props.setState(false);

        if( props.closeCallback && typeof props.closeCallback === "function" ) {
            props.closeCallback();
        }
    }

    useEffect(() => {
        clg("MODAL: ", props.title, props.bodyClassName);
        const closeOnEsc = (e) => {
          if(e.keyCode === 27){
            close();
          }
        }
        window.addEventListener('keydown', closeOnEsc)
      return () => window.removeEventListener('keydown', closeOnEsc)
    },[])

    useOutsideAlerter(modalBodyRef, close, /* modalId */);

    return (
        <AnimatePresence>
            {props.state && (
                <motion.div className="container-fluid modal-container" id={modalId}
                    initial={{ y: "-100%" }}
                    animate={{ y: 0 }}
                    exit={{ y: "-100%" }}
                    transition={{ type: "", duration: 0.3 }}>
                    <div className="row modal-row">
                        <div className={"col-xl-6 col-lg-8 col-md-10 col-12 modal-body" + ( props.bodyClassName ? " " + props.bodyClassName : "" )} ref={modalBodyRef} >

                            <div className="up">
                                <div className="row">
                                    <div className="title">
                                        {props.title}
                                    </div>
                                    <div className="close" onClick={ () => close() }><i className="fas fa-times"></i></div>
                                </div>
                            </div>

                            <div className="mid">
                                {props.children}
                            </div>

                            { !props.hideFooter && (
                            <div className="row down">
                                <Button text="Bezárás" className="btn-primary small-icon" icon="fas fa-times" onClick={ () => close() }/>
                                {
                                    props.modalDownContent && (
                                        props.modalDownContent
                                    )
                                }
                            </div>
                            )}
                            
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export default Modal;

